import Edit from "@mui/icons-material/Edit";
import PersonRemove from "@mui/icons-material/PersonRemove";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { HXMenuButton } from "./HXMenuButton";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
export const AdminUserListViewParent = styled(FlexColumnDiv) `
    gap: 16px;
    padding-top: 16px;
`;
export const ActionButton = styled(HXMenuButton).attrs({ secondary: true, startIcon: null, label: "" }) `
    border-color: ${colors.black_12};
    color: ${colors.black_lighter};
    padding: 8px;
    min-width: 0;

    &:hover {
        border-color: ${colors.black_lighter};
    }

    & .MuiButton-endIcon {
        margin: 0;
    }
`;
export const EditIcon = styled(Edit) `
    &&& {
        color: ${colors.black_lighter};
    }
`;
export const RemoveIcon = styled(PersonRemove) `
    li:not(.Mui-disabled) && {
        color: ${colors.tulip_main};
    }
`;
export const DestructiveText = styled.div `
    li:not(.Mui-disabled) & {
        color: ${colors.tulip_main};
    }
`;
export const AvatarAndName = styled(FlexRowDiv) `
    align-items: center;
    gap: 8px;
`;
export const UserCount = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
